import { capitalizeFirstLetter } from "./ConstantData";
import { NUMBER } from "./MagicNumber";

/* Function to compare two arrya and find updated data only.*/
export const findUpdatedData = (oldArray, newArray) => {
    const updatedData = [];
    for (let i = NUMBER.ZERO; i < oldArray?.length; i++) {
      const oldItem = oldArray[i];
      const newItem = newArray[i];
      if (oldItem?.is_visible !== newItem?.is_visible) {
        updatedData.push(newItem);
      }
    }
    return updatedData;
}

export const findFormError = (formData, identity) => {
    return new Promise((resolve, reject) => {
      const errors = [];
      jobRequired(formData, errors);
      propayNameRequired(formData?.name, errors);
      managerRequired(formData?.manager_id, errors);
      amountRequired(formData, errors);
      leadPayAmountRequired(formData, errors);
      workerSplitPercentRequired(formData, errors);
      leadpayWorkerRequired(formData, errors);
      leadpaySplitPercentRequired(formData, errors);
      bonusPoolRequired(formData, errors);
      notesRequired(formData, errors);
      workerDataRequired(formData?.employee_wage_ids, errors);
      notesDataRequired(formData, errors);
      leadPayDataRequired(formData, errors);
      if (formData?.milestone_ids?.length) {
       // costCodeRequired(identity?.company?.is_cost_code_required, formData?.milestone_ids, errors);
        milestonesDataRequired(formData?.milestone_ids, formData?.budget_option, errors);
      }
      //  else {
      //   costCodeRequired(identity?.company?.is_cost_code_required, formData?.cost_code_ids, errors);
      // }
      if (errors.length > 0) {
        resolve(errors);
      } else {
        resolve(errors);
      }
    });
  };

const jobRequired = (data, errorArray) => {
  if(data.hasOwnProperty('second_job_id')){
    if(data.job_id || data.second_job_id){
      return errorArray;
    }else {
      errorArray?.push('Jobs are required. Please assign any one.');
      return errorArray;
    }
  }
  if (data.job_id) {
    return errorArray;
  } else {
    errorArray?.push('Job is required. Please assign one.');
    return errorArray;
  }
}

const propayNameRequired = (data, errorArray) => {
  if (data) {
    return errorArray;
  } else {
    errorArray?.push('ProPay Title is required.');
    return errorArray;
  }
}

const leadpaySplitPercentRequired = (data, errorArray) => {
    if (data?.is_change_lead_pay) {
      const bonusSum = (data?.leadpay_employee_wage_ids || []).reduce((sum, employee) => {
        return sum + (Number(employee?.lead_pay_per) || 0);
      }, 0);
      if(bonusSum !== 100){
      errorArray?.push(errorArray?.length > 1 ? 'LeadPay amount split requires the percentage to equal to 100%':'LeadPay budget split requires the percentage to equal to 100%. Please fix.');
      }
    }
}

const leadpayWorkerRequired = (data, errorArray) => {
  if (data?.is_change_lead_pay && !data?.leadpay_employee_wage_ids?.length) {
    errorArray?.push('Leadpay member not added.');
  }
}

const managerRequired = (data, errorArray) => {
  if (!data) {
    errorArray?.push('Manger is required. Please assign one.');
  }
}

const costCodeRequired = (isCostCodeRequired, costCodeIds, errorArray) => {
  if (isCostCodeRequired && (!costCodeIds || costCodeIds?.length === 0)) {
    errorArray?.push('Cost Codes is required. Please assign at least one.');
  }
}

const amountRequired = (formData, errorArray) => {
  if(!formData?.milestone_ids?.length){
  if(formData?.budget_option === 'hours'){
    if(!formData?.budget_hours){
      errorArray?.push('Please add a budget it is a required field.')
    }
  }else{
    if(!formData?.amount){
      errorArray?.push('Please add a budget it is a required field.')
    }
  }
 }
}

const milestonesDataRequired = (milestoneIds,budgetOption, errorArray) => {
  if (milestoneIds && milestoneIds.length > 0) {
    milestoneIds.forEach((milestone, index) => {
      if(budgetOption === 'hours'){
        if (!milestone.name || !milestone.budget_hours) {
          errorArray?.push(milestoneIds.length > 1 ? `Milestone ${milestone?.name ? milestone ?.name : index + 1}` : `Milestone ${milestone?.name ? milestone ?.name : index + 1} is missing required fields.`);
        }
      }else{
        if (!milestone.name || !milestone.amount ) {
          errorArray?.push(milestoneIds.length > 1 ? `Milestone ${milestone?.name ? milestone ?.name : index + 1}` : `Milestone ${milestone?.name ? milestone ?.name : index + 1} is missing required fields.`);
        }
      }
    });
  }
}

const leadPayDataRequired = (data, errorArray) => {
  if (data?.is_change_lead_pay && data?.leadpay_employee_wage_ids && data?.leadpay_employee_wage_ids?.length > 0) {
    data?.leadpay_employee_wage_ids.forEach((employee, index) => {
        if (!employee?.employee_id || !employee?.lead_pay_per) {
          errorArray?.push(data?.leadpay_employee_wage_ids?.length > 1 ? `Lead pay row ${index + 1}` : `Lead pay row ${index + 1} is missing required fields.`);
        }
    });
  }
}

const leadPayAmountRequired = (data, errorArray) => {
  if (data?.is_change_lead_pay && !data?.leadpay_amount) {
    errorArray?.push('Leadpay amount is required when leadpay toggle is on.');
  }
}

const workerDataRequired = (employeeWageIds, errorArray) => {
  if (employeeWageIds && employeeWageIds.length > 0) {
    employeeWageIds.forEach((worker, index) => {
        if (!worker?.employee_id || !worker?.base_wage) {
          errorArray?.push(employeeWageIds?.length > 1 ? `Row ${index + 1} in add worker` : `Row ${index + 1} in add worker is missing required fields.`);
        }
    });
  }
}

const notesDataRequired = (data, errorArray) => {
  if (data?.allow_task && data?.task_ids && data?.task_ids.length > 0) {
    data?.task_ids?.forEach((worker, index) => {
        if (!worker?.name) {
          errorArray?.push(data?.task_ids?.length > 1 ? `Row ${index + 1} in add notes` : `Row ${index + 1} in add notes is missing required fields.`);
        }
    });
  }
}

const workerSplitPercentRequired = (data, errorArray) => {
  if (data?.bonus_split_type === 'by_percentage' && data?.employee_wage_ids?.length) {
    const bonusSum = (data?.employee_wage_ids || []).reduce((sum, employee) => {
      return sum + (Number(employee?.bonus_per) || 0);
    }, 0);
    if(bonusSum !== 1){
    errorArray?.push(errorArray?.length > 1 ? 'Percentage split type requires a total percentage equal to 100%.':'Percentage split type requires a total percentage equal to 100%. Please fix.');
    }
  }
}

const bonusPoolRequired = (data, errorArray) => {
  if (data?.is_bonus_pool_enabled && !data?.worker_bonus_percent) {
    errorArray?.push(errorArray?.length > 1 ? 'Workers Bonus Pool percentage must be greater than zero.' : 'Workers Bonus Pool percentage must be greater than zero. Please fix.');
  }
}

const notesRequired = (data, errorArray) => {
  if (data?.allow_task && !data?.task_ids?.length) {
    errorArray?.push(errorArray?.length > 1 ? 'Notes are required when the notes section is enabled.':'Notes are required when the notes section is enabled. Please fix.');
  }
}

export const CustomToast = ({ errors }) => {
  const allErrors = [
    'Job',
    'ProPay Title',
    'Leadpay member not added.',
    'Manger',
    'Cost Codes',
    'budget',
    'Leadpay amount',
  ]
  const multiError = ['is missing required fields.']

  if(errors?.length > 1){
    errors.map((error) => {
      const matchingError = allErrors.find((keyword) => error.includes(keyword));

      if (matchingError) {
        const index = errors.indexOf(error);
        errors.splice(index, 1, capitalizeFirstLetter(matchingError));
      }

      return error;
    });
    return (
      <div>
    {errors.length > 0 && (
      <>
        <div>Please fix the required fields:</div>
        {errors.map((field, index) => {
          return(
          <div key={index}>{multiError.find((keyword) => field?.includes(keyword))
            ? field.replace(new RegExp(multiError.join('|'), 'g'), '')
            : field}</div>
        )})}
        <div>Once complete, you can finalize the ProPay.</div>
      </>
    )}
  </div>
    );
  }
  const singleError = ['Add Worker row', 'Lead pay row', 'Milestone ']
  return (
    <div>
      {errors?.length && errors.map((error, index) => (
        <div key={index}>{
          singleError.find((keyword) => error?.includes(keyword)) ? `${error} is missing required fields.` : error}</div>
      ))}
    </div>
  );
};

export const CustomLeadpayToastToast = () => {
  return (
    <div className="lead-pay-toast">
      <span className="lead-pay-toast-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M7.83391 2.50195C8.79641 0.835286 11.2031 0.835286 12.1647 2.50195L18.2939 13.1253C19.2556 14.792 18.0522 16.8753 16.1281 16.8753H3.87058C1.94641 16.8753 0.743909 14.792 1.70558 13.1253L7.83308 2.50195H7.83391ZM9.99974 6.87445C10.1655 6.87445 10.3245 6.9403 10.4417 7.05751C10.5589 7.17472 10.6247 7.33369 10.6247 7.49945V10.6245C10.6247 10.7902 10.5589 10.9492 10.4417 11.0664C10.3245 11.1836 10.1655 11.2495 9.99974 11.2495C9.83398 11.2495 9.67501 11.1836 9.5578 11.0664C9.44059 10.9492 9.37474 10.7902 9.37474 10.6245V7.49945C9.37474 7.33369 9.44059 7.17472 9.5578 7.05751C9.67501 6.9403 9.83398 6.87445 9.99974 6.87445ZM9.99974 13.7495C10.1655 13.7495 10.3245 13.6836 10.4417 13.5664C10.5589 13.4492 10.6247 13.2902 10.6247 13.1245C10.6247 12.9587 10.5589 12.7997 10.4417 12.6825C10.3245 12.5653 10.1655 12.4995 9.99974 12.4995C9.83398 12.4995 9.67501 12.5653 9.5578 12.6825C9.44059 12.7997 9.37474 12.9587 9.37474 13.1245C9.37474 13.2902 9.44059 13.4492 9.5578 13.5664C9.67501 13.6836 9.83398 13.7495 9.99974 13.7495Z" fill="#FAA734" />
        </svg>
      </span>
      <div className="lead-pay-toast-body">
        <h4>LeadPay is enabled. </h4>
        <p>Actions are required:</p>
        <ul>
          <li>Add bonus amount and at least one user</li>
        </ul>
      </div>
    </div>
  );
};

export const findpropayWithoutBudget = (record) => {
  switch(record?.budget_options){
      case 'hours':
          if(record?.automation_id && !record?.budget_hours){
              return true;
          }else{
              return false;
          }
      default:
          if(record?.automation_id && !record?.budget){
              return true;
          }else{
              return false;
          }
  }
}
